const socialwallContainer = document.querySelector('.home-socialwall')
const socialwallBtn = document.querySelector('.home-socialwall__btn button')

!!socialwallBtn &&
    socialwallBtn.addEventListener('click', function(){
        socialwallContainer.classList.toggle('expanded')
        socialwallBtn.classList.toggle('expanded')
    })
